import { useQuery } from '@apollo/client'
import { useParams } from 'react-router'
import { PageErrorBoundary } from '@/components/error-boundaries/page-error-boundary'
import { LayoutPage } from '@/components/layout/page'
import { gql } from '@/lib/graphql/gql'
import { TemplatePageFallback } from '@/routes/template/fallback'
import { TemplatePage } from '@/routes/template/page'
import type {
  TemplateDisplayNameQuery,
  TemplateDisplayNameQueryVariables,
} from '@/routes/template/index.types.gen'

const TEMPLATE_DISPLAY_NAME_QUERY = gql`
  query TemplateDisplayName($name: String!) {
    templateByName(name: $name) {
      id
      displayName
    }
  }
`

export const Template = () => {
  const { name = '' } = useParams()
  const { data } = useQuery<
    TemplateDisplayNameQuery,
    TemplateDisplayNameQueryVariables
  >(TEMPLATE_DISPLAY_NAME_QUERY, {
    variables: { name },
    fetchPolicy: 'cache-only',
  })

  const displayName = data?.templateByName?.displayName || 'Loading'

  return (
    <PageErrorBoundary>
      <LayoutPage
        browserTitle={`${displayName} template`}
        fallback={<TemplatePageFallback />}
      >
        <TemplatePage />
      </LayoutPage>
    </PageErrorBoundary>
  )
}
